'use strict'


module.exports = {

    checkMembername(name)
    {

        if (!name) {
            name = "anonymous";
        }

        return name;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/xapijs/src/functions/common/functions.js
// module id = 2Ymg
// module chunks = 2 3 4 5 6